import { render, staticRenderFns } from "./CollectionPointModal.vue?vue&type=template&id=15182b2e"
import script from "./CollectionPointModal.vue?vue&type=script&lang=js"
export * from "./CollectionPointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports